(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  function cartAddDeliveryDays(days, excludeWeekends) {
    var date = new Date();
    date.setHours(12, 0, 0, 0);
    var added = 0;
    while (added < days) {
      date.setDate(date.getDate() + 1);
      if (!excludeWeekends || (date.getDay() !== 0 && date.getDay() !== 6)) added += 1;
    }
    if (excludeWeekends) while (date.getDay() === 0 || date.getDay() === 6) date.setDate(date.getDate() + 1);
    return date;
  }

  function cartFormatDeliveryDate(date) {
    return new Intl.DateTimeFormat(document.documentElement.lang || 'de-CH', { weekday: 'short', day: '2-digit', month: 'short' }).format(date);
  }

  function renderCartDelivery(root) {
    renderCartTradeIn(root);
    root.querySelectorAll('[data-cart-delivery-root]').forEach(function (cartRoot) {
      var excludeWeekends = cartRoot.dataset.excludeWeekends === 'true';
      cartRoot.querySelectorAll('[data-cart-delivery-date]').forEach(function (element) {
        var minDays = Number(element.dataset.minDays || 0);
        var maxDays = Number(element.dataset.maxDays || minDays);
        var minDate = cartFormatDeliveryDate(cartAddDeliveryDays(minDays, excludeWeekends));
        var maxDate = cartFormatDeliveryDate(cartAddDeliveryDays(maxDays, excludeWeekends));
        element.textContent = minDays === maxDays ? minDate : minDate + ' – ' + maxDate;
      });
    });
  }

  document.addEventListener('input', function (event) {
    var input = event.target.closest('[data-cart-quantity]');
    if (!input) return;
    var item = input.closest('[data-cart-item-delivery]');
    var root = input.closest('[data-cart-delivery-root]');
    var flow = item.dataset.deliveryMode;
    if (flow === 'auto') {
      var managed = item.dataset.managed === 'true';
      var inventory = Number(item.dataset.inventory || 0);
      flow = item.dataset.available === 'false' || (managed && Number(input.value || 0) > inventory) ? 'production' : 'stock';
    }
    item.dataset.flow = flow;
    item.querySelectorAll('[data-cart-flow]').forEach(function (node) { node.hidden = node.dataset.cartFlow !== flow; });
    var status = item.querySelector('[data-cart-delivery-status]');
    if (status) status.textContent = flow === 'stock' ? root.dataset.stockLabel : root.dataset.productionLabel;
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { renderCartDelivery(document); });
  else renderCartDelivery(document);
  document.addEventListener('shopify:section:load', function (event) { renderCartDelivery(event.target); });

  function cartDiscountApplied(cart, value) {
    const wanted = value.split(',').map(code => code.trim().toUpperCase()).filter(Boolean);
    const applications = [...(cart.cart_level_discount_applications || [])];
    (cart.items || []).forEach(item => {
      (item.line_level_discount_allocations || []).forEach(allocation => {
        if (allocation.discount_application) applications.push(allocation.discount_application);
      });
    });
    return wanted.length > 0 && wanted.every(code => {
      const acceptedCode = (cart.discount_codes || []).some(discount =>
        discount.applicable === true && String(discount.code).toUpperCase() === code
      );
      return acceptedCode || applications.some(discount =>
        discount.type === 'discount_code' && String(discount.code || discount.title || '').toUpperCase() === code
      );
    });
  }

  function cartDiscountMessage(root, text, error) {
    const message = root.querySelector('[data-cart-discount-message]');
    if (!message) return;
    message.textContent = text;
    message.dataset.state = error ? 'error' : 'success';
    message.setAttribute('role', error ? 'alert' : 'status');
    message.hidden = false;
    const input = root.querySelector('[data-cart-discount-input]');
    if (input) input.setAttribute('aria-invalid', String(error));
    message.focus({ preventScroll: true });
  }

  async function applyCartDiscount(root) {
    if (root.dataset.discountBusy === 'true') return;
    const input = root.querySelector('[data-cart-discount-input]');
    if (!input) return;
    const code = input.value.trim();
    const previousCodes = root.dataset.activeDiscountCodes || '';
    if (!code) {
      cartDiscountMessage(root, root.dataset.discountEmpty, true);
      input.focus();
      return;
    }
    const form = input.closest('form');
    if (!form.reportValidity()) return;
    const payload = new FormData(form);
    payload.set('discount', code);
    payload.set('sections', root.dataset.cartSectionId);
    payload.set('sections_url', window.location.pathname + window.location.search);
    const controls = [...form.querySelectorAll('input, button, textarea')].filter(control => !control.disabled);
    root.dataset.discountBusy = 'true';
    root.setAttribute('aria-busy', 'true');
    controls.forEach(control => { control.disabled = true; });
    const message = root.querySelector('[data-cart-discount-message]');
    if (message) message.hidden = true;
    try {
      const route = window.Shopify?.routes?.root || '/';
      const response = await fetch(route + 'cart/update.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: payload
      });
      if (!response.ok) throw new Error();
      let cart = await response.json();
      const applied = cartDiscountApplied(cart, code);
      let previousKept = false;
      if (!applied && previousCodes && previousCodes.toUpperCase() !== code.toUpperCase()) {
        const restore = new FormData();
        restore.set('discount', previousCodes);
        restore.set('sections', root.dataset.cartSectionId);
        restore.set('sections_url', window.location.pathname + window.location.search);
        const restored = await fetch(route + 'cart/update.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: restore
        });
        if (!restored.ok) throw new Error();
        cart = await restored.json();
        previousKept = cartDiscountApplied(cart, previousCodes);
      }
      const sectionHtml = cart.sections && cart.sections[root.dataset.cartSectionId];
      if (!sectionHtml) {
        window.location.reload();
        return;
      }
      const rendered = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const next = rendered.querySelector('[data-cart-delivery-root]');
      if (!next) {
        window.location.reload();
        return;
      }
      root.replaceWith(next);
      renderCartDelivery(document);
      const nextInput = next.querySelector('[data-cart-discount-input]');
      if (!applied && nextInput) nextInput.value = code;
      cartDiscountMessage(next, applied ? next.dataset.discountSuccess : previousKept ? next.dataset.discountKept : next.dataset.discountInvalid, !applied);
      document.querySelectorAll('.cart-count').forEach(count => {
        count.textContent = String(cart.item_count);
        count.hidden = Number(cart.item_count) === 0;
      });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    } catch {
      cartDiscountMessage(root, root.dataset.discountError, true);
    } finally {
      root.dataset.discountBusy = 'false';
      root.removeAttribute('aria-busy');
      controls.forEach(control => { if (control.isConnected) control.disabled = false; });
    }
  }

  document.addEventListener('click', event => {
    const button = event.target.closest('[data-cart-discount-apply]');
    if (!button) return;
    event.preventDefault();
    applyCartDiscount(button.closest('[data-cart-delivery-root]'));
  });

  document.addEventListener('keydown', event => {
    if (event.key !== 'Enter' || event.isComposing) return;
    const input = event.target.closest('[data-cart-discount-input]');
    if (!input) return;
    event.preventDefault();
    event.stopPropagation();
    applyCartDiscount(input.closest('[data-cart-delivery-root]'));
  });


  function renderCartTradeIn(root) {
    root.querySelectorAll('[data-cart-trade-in]').forEach(card => {
      const heading = card.querySelector('[data-cart-trade-heading]');
      if (!heading) return;
      const amount = Number(card.dataset.creditEur);
      const currency = card.dataset.currency;
      const exchange = window.Shopify && window.Shopify.currency;
      const rate = currency === 'EUR' ? 1 : Number(exchange && exchange.rate);
      const convertible = currency === 'EUR' || card.dataset.baseCurrency === 'EUR' && exchange && exchange.active === currency && Number.isFinite(rate) && rate > 0;
      if (!Number.isFinite(amount) || amount <= 0 || !convertible) return;
      try {
        const locale = document.documentElement.lang || 'de';
        const fractionDigits = new Intl.NumberFormat(locale, { style: 'currency', currency }).resolvedOptions().maximumFractionDigits;
        const factor = Math.pow(10, fractionDigits);
        const converted = Math.round(amount * rate * factor) / factor;
        const formatted = new Intl.NumberFormat(locale, {
          style: 'currency', currency,
          minimumFractionDigits: Number.isInteger(converted) ? 0 : fractionDigits,
          maximumFractionDigits: fractionDigits
        }).format(converted);
        heading.textContent = heading.dataset.titleTemplate.replace('__AMOUNT__', formatted);
      } catch {}
    });
  }


  document.addEventListener('click', event => {
    const button = event.target.closest('[data-cart-item-toggle]');
    if (!button || !window.matchMedia('(max-width: 600px)').matches) return;
    const item = button.closest('[data-cart-item-delivery]');
    if (!item) return;
    const expanded = button.getAttribute('aria-expanded') !== 'true';
    item.classList.toggle('is-expanded', expanded);
    button.setAttribute('aria-expanded', String(expanded));
    button.querySelector('[data-cart-item-toggle-label]').textContent = expanded ? button.dataset.collapseLabel : button.dataset.expandLabel;
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  if (!customElements.get('rg-collection-feed')) {
    customElements.define('rg-collection-feed', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.grid = this.querySelector('[data-rg-product-grid]');
        this.loader = this.querySelector('[data-rg-load]');
        this.status = this.querySelector('[data-rg-load-status]');
        this.link = this.querySelector('[data-rg-load-next]');
        if (!this.grid || !this.loader || !this.status || !this.link) return;
        this.initialized = true;
        this.loading = false;
        this.failed = false;
        this.loadedUrls = new Set();
        this.events = new AbortController();
        this.link.addEventListener('click', (event) => {
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.loadNext();
        }, { signal: this.events.signal });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting) && !this.failed) this.loadNext();
          }, { rootMargin: '600px 0px' });
          this.setAttribute('data-ready', '');
          this.observer.observe(this.loader);
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.request?.abort();
        this.events?.abort();
        this.initialized = false;
      }

      async loadNext() {
        if (this.loading || !this.link || !this.isConnected) return;
        const pageUrl = new URL(this.link.getAttribute('href'), window.location.href);
        if (pageUrl.origin !== window.location.origin || this.loadedUrls.has(pageUrl.href)) return;
        const currentUrl = new URL(window.location.href);
        const preservedKeys = new Set([...currentUrl.searchParams.keys()].filter((key) => key === 'sort_by' || key === 'preview_theme_id' || key.startsWith('filter.')));
        preservedKeys.forEach((key) => {
          if (!pageUrl.searchParams.has(key)) currentUrl.searchParams.getAll(key).forEach((value) => pageUrl.searchParams.append(key, value));
        });
        const requestUrl = new URL(pageUrl);
        requestUrl.searchParams.set('section_id', this.dataset.sectionId);
        const controller = new AbortController();
        this.request = controller;
        this.loading = true;
        this.failed = false;
        this.removeAttribute('data-error');
        this.setAttribute('data-loading', '');
        this.grid.setAttribute('aria-busy', 'true');
        this.link.setAttribute('aria-disabled', 'true');
        this.status.textContent = this.dataset.loadingMessage;
        this.observer?.disconnect();
        const timeout = window.setTimeout(() => controller.abort(), 15000);
        try {
          const response = await fetch(requestUrl.href, { signal: controller.signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error('Collection request failed');
          const html = await response.text();
          if (!this.isConnected || controller.signal.aborted) return;
          const document = new DOMParser().parseFromString(html, 'text/html');
          const incoming = document.querySelector('rg-collection-feed');
          if (!incoming || incoming.dataset.sectionId !== this.dataset.sectionId) throw new Error('Collection section missing');
          const productIds = new Set([...this.grid.querySelectorAll('[data-product-id]')].map((card) => card.dataset.productId));
          const cards = [...incoming.querySelectorAll('[data-rg-product-grid] > [data-product-id]')].filter((card) => {
            if (productIds.has(card.dataset.productId)) return false;
            productIds.add(card.dataset.productId);
            return true;
          });
          if (!cards.length) throw new Error('Collection products missing');
          this.grid.append(...cards);
          this.loadedUrls.add(pageUrl.href);
          const nextLink = incoming.querySelector('[data-rg-load-next]');
          if (nextLink) {
            this.link.setAttribute('href', nextLink.getAttribute('href'));
            this.status.textContent = this.dataset.loadedMessage.replace('__count__', String(cards.length));
          } else {
            this.link.remove();
            this.link = null;
            this.status.textContent = this.dataset.completeMessage;
          }
        } catch (error) {
          if (!this.isConnected || this.request !== controller) return;
          this.failed = true;
          this.setAttribute('data-error', '');
          this.status.textContent = this.dataset.errorMessage;
        } finally {
          window.clearTimeout(timeout);
          if (this.isConnected && this.request === controller) {
            this.loading = false;
            this.removeAttribute('data-loading');
            this.grid.removeAttribute('aria-busy');
            this.link?.removeAttribute('aria-disabled');
            if (this.link && !this.failed) this.observer?.observe(this.loader);
          }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-preorder"]) return;
  try {
    
  document.addEventListener('pointerover', function (event) {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var thumb = event.target.closest('[data-media-target]');
    if (!thumb || thumb.contains(event.relatedTarget)) return;
    activateMedia(thumb.closest('[data-product-gallery]'), thumb.dataset.mediaTarget, false);
  });

  document.addEventListener('click', function (event) {
    var target = event.target.closest('[data-media-target]');
    if (target) activateMedia(target.closest('[data-product-gallery]'), target.dataset.mediaTarget);
    var gallery = event.target.closest('[data-product-gallery]');
    if (gallery && (event.target.closest('[data-gallery-prev]') || event.target.closest('[data-gallery-next]'))) {
      var thumbs = Array.from(gallery.querySelectorAll('[data-media-target]'));
      var current = gallery.querySelector('[data-media-target].is-active');
      var index = Math.max(0, thumbs.indexOf(current));
      index += event.target.closest('[data-gallery-prev]') ? -1 : 1;
      if (index < 0) index = thumbs.length - 1;
      if (index >= thumbs.length) index = 0;
      activateMedia(gallery, thumbs[index].dataset.mediaTarget);
    }
    var section = event.target.closest('[data-product-section]');
    if (!section) return;
    var carouselButton = event.target.closest('[data-carousel-prev], [data-carousel-next]');
    if (carouselButton) {
      var carousel = carouselButton.closest('[data-upsell], [data-video-gallery]').querySelector('[data-carousel-track]');
      var step = carousel.firstElementChild ? carousel.firstElementChild.getBoundingClientRect().width + 10 : carousel.clientWidth;
      carousel.scrollBy({ left: carouselButton.hasAttribute('data-carousel-prev') ? -step : step, top: carouselButton.hasAttribute('data-carousel-prev') ? -step : step, behavior: 'smooth' });
    }
    var quantity = section.querySelector('[data-quantity-input]');
    if (quantity && event.target.closest('[data-quantity-minus]')) quantity.value = Math.max(1, Number(quantity.value || 1) - 1);
    if (quantity && event.target.closest('[data-quantity-plus]')) quantity.value = Math.max(1, Number(quantity.value || 1) + 1);
    if (event.target.closest('[data-mobile-submit]') && section.querySelector('[data-product-submit]')) section.querySelector('[data-product-submit]').click();
  });

  document.addEventListener('change', function (event) {
    var upsellSelector = event.target.closest('[data-upsell-variant]');
    if (upsellSelector) {
      var upsellOption = upsellSelector.options[upsellSelector.selectedIndex];
      upsellSelector.closest('form').querySelector('[data-upsell-price]').textContent = upsellOption.dataset.price;
      return;
    }
    var selector = event.target.closest('[data-product-variant-selector]');
    if (!selector) return;
    var option = selector.options[selector.selectedIndex];
    var section = selector.closest('[data-product-section]');
    var available = option.dataset.available === 'true';
    var price = section.querySelector('[data-product-price]');
    if (price) price.textContent = option.dataset.price;
    var mobilePrice = section.querySelector('[data-mobile-price]');
    if (mobilePrice) mobilePrice.textContent = option.dataset.price;
    var compare = section.querySelector('[data-product-compare-price]');
    if (compare) {
      compare.textContent = option.dataset.comparePrice || '';
      compare.hidden = !!section.querySelector('[data-submit-price]') || !option.dataset.comparePrice;
    }
    var sale = section.querySelector('[data-sale-badge]');
    var priceRaw = Number(option.dataset.priceRaw || 0);
    var compareRaw = Number(option.dataset.compareRaw || 0);
    if (sale) {
      sale.textContent = compareRaw > priceRaw ? '-' + Math.round((compareRaw - priceRaw) * 100 / compareRaw) + '%' : '';
      sale.hidden = compareRaw <= priceRaw;
    }
    var button = section.querySelector('[data-product-submit]');
    var mobileButton = section.querySelector('[data-mobile-submit]');
    if (button) {
      button.disabled = !available;
      button.querySelector('[data-submit-label]').textContent = available ? button.dataset.addLabel : button.dataset.soldLabel;
    }
    if (mobileButton) mobileButton.disabled = !available;
    var submitPrice = button && button.querySelector('[data-submit-price]');
    if (submitPrice) {
      submitPrice.textContent = ' - ' + option.dataset.price;
      submitPrice.hidden = !available;
    }
    var mobileSubmitPrice = mobileButton && mobileButton.querySelector('[data-mobile-submit-price]');
    if (mobileSubmitPrice) {
      mobileSubmitPrice.textContent = ' - ' + option.dataset.price;
      mobileSubmitPrice.hidden = !available;
    }
    var stock = section.querySelector('[data-stock-status]');
    var inventory = Number(option.dataset.inventory || 0);
    var managed = option.dataset.managed === 'true';
    var threshold = Number(section.dataset.lowStockThreshold || 5);
    var lowStock = available && managed && inventory > 0 && inventory <= threshold;
    if (stock) {
      stock.classList.toggle('is-sold-out', !available);
      stock.classList.toggle('is-low', lowStock);
      var stockText = stock.querySelector('[data-stock-text]');
      if (stockText) {
        var statusLabel = available ? (lowStock ? section.dataset.lowStockLabel : section.dataset.inStockLabel) : section.dataset.soldOutLabel;
        if (lowStock && section.dataset.showStockQuantity === 'true') statusLabel += ' · ' + inventory;
        stockText.textContent = statusLabel;
      }
    }
    var delivery = section.querySelector('[data-delivery-text]');
    if (delivery) delivery.hidden = !available;
    var deliveryMode = section.dataset.deliveryMode;
    if (deliveryMode === 'auto') deliveryMode = available && (!managed || inventory > 0) ? 'stock' : 'production';
    section.querySelectorAll('[data-delivery-flow]').forEach(function (flow) { flow.hidden = flow.dataset.deliveryFlow !== deliveryMode; });
    var deliveryStatus = section.querySelector('[data-delivery-status]');
    if (deliveryStatus) {
      var deliveryLabel = deliveryMode === 'stock' ? section.dataset.stockFlowLabel : section.dataset.productionFlowLabel;
      if (deliveryMode === 'stock' && inventory > 0 && section.dataset.flowShowStockCount === 'true') deliveryLabel = inventory + ' ' + deliveryLabel;
      deliveryStatus.textContent = deliveryLabel;
    }
    var sku = section.querySelector('[data-product-sku]');
    if (sku) sku.textContent = option.dataset.sku || '—';
    if (option.dataset.mediaId) activateMedia(section.querySelector('[data-product-gallery]'), option.dataset.mediaId);
    var url = new URL(window.location.href);
    url.searchParams.set('variant', option.value);
    window.history.replaceState({}, '', url.toString());
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-upsell-form]');
    if (!form) return;
    event.preventDefault();
    var button = form.querySelector('button[type="submit"]');
    button.disabled = true;
    var root = window.Shopify && Shopify.routes && Shopify.routes.root || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    }).then(function (response) {
      if (!response.ok) throw new Error('cart');
      return fetch(root + 'cart.js');
    }).then(function (response) { return response.json(); }).then(function (cart) {
      document.querySelectorAll('.cart-count').forEach(function (count) { count.textContent = cart.item_count; });
      button.textContent = button.dataset.addedLabel;
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    }).catch(function () {
      form.submit();
    }).finally(function () {
      button.disabled = false;
      window.setTimeout(function () { button.textContent = button.dataset.addLabel; }, 2200);
    });
  });

  function activateMedia(gallery, mediaId, scrollThumb) {
    if (!gallery || !mediaId) return;
    gallery.querySelectorAll('[data-media-id]').forEach(function (item) {
      var active = item.dataset.mediaId === String(mediaId);
      item.hidden = !active;
      item.classList.toggle('is-active', active);
      if (!active) item.querySelectorAll('video').forEach(function (video) { video.pause(); });
    });
    gallery.querySelectorAll('[data-media-target]').forEach(function (thumb) {
      var active = thumb.dataset.mediaTarget === String(mediaId);
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
      if (active && scrollThumb !== false) thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    });
  }

  function addDeliveryDays(days, excludeWeekends) {
    var date = new Date();
    date.setHours(12, 0, 0, 0);
    var added = 0;
    while (added < days) {
      date.setDate(date.getDate() + 1);
      if (!excludeWeekends || (date.getDay() !== 0 && date.getDay() !== 6)) added += 1;
    }
    if (excludeWeekends) {
      while (date.getDay() === 0 || date.getDay() === 6) date.setDate(date.getDate() + 1);
    }
    return date;
  }

  function formatDeliveryDate(date) {
    var locale = document.documentElement.lang || 'de-CH';
    return new Intl.DateTimeFormat(locale, { weekday: 'short', day: '2-digit', month: 'short' }).format(date);
  }

  function renderDeliveryDates(section) {
    var excludeWeekends = section.dataset.excludeWeekends === 'true';
    section.querySelectorAll('[data-delivery-date]').forEach(function (element) {
      var minDays = Number(element.dataset.minDays || 0);
      var maxDays = Number(element.dataset.maxDays || minDays);
      var minDate = formatDeliveryDate(addDeliveryDays(minDays, excludeWeekends));
      var maxDate = formatDeliveryDate(addDeliveryDays(maxDays, excludeWeekends));
      element.textContent = minDays === maxDays ? minDate : minDate + ' – ' + maxDate;
    });
  }

  function initializeDeliveryDates(root) {
    root.querySelectorAll('[data-product-section]').forEach(renderDeliveryDates);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeDeliveryDates(document); });
  } else {
    initializeDeliveryDates(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initializeDeliveryDates(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('pointerover', function (event) {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var thumb = event.target.closest('[data-media-target]');
    if (!thumb || thumb.contains(event.relatedTarget)) return;
    activateMedia(thumb.closest('[data-product-gallery]'), thumb.dataset.mediaTarget, false);
  });

  document.addEventListener('click', function (event) {
    var target = event.target.closest('[data-media-target]');
    if (target) activateMedia(target.closest('[data-product-gallery]'), target.dataset.mediaTarget);
    var gallery = event.target.closest('[data-product-gallery]');
    if (gallery && (event.target.closest('[data-gallery-prev]') || event.target.closest('[data-gallery-next]'))) {
      var thumbs = Array.from(gallery.querySelectorAll('[data-media-target]'));
      var current = gallery.querySelector('[data-media-target].is-active');
      var index = Math.max(0, thumbs.indexOf(current));
      index += event.target.closest('[data-gallery-prev]') ? -1 : 1;
      if (index < 0) index = thumbs.length - 1;
      if (index >= thumbs.length) index = 0;
      activateMedia(gallery, thumbs[index].dataset.mediaTarget);
    }
    var section = event.target.closest('[data-product-section]');
    if (!section) return;
    var carouselButton = event.target.closest('[data-carousel-prev], [data-carousel-next]');
    if (carouselButton) {
      var carousel = carouselButton.closest('[data-upsell], [data-video-gallery]').querySelector('[data-carousel-track]');
      var step = carousel.firstElementChild ? carousel.firstElementChild.getBoundingClientRect().width + 10 : carousel.clientWidth;
      carousel.scrollBy({ left: carouselButton.hasAttribute('data-carousel-prev') ? -step : step, top: carouselButton.hasAttribute('data-carousel-prev') ? -step : step, behavior: 'smooth' });
    }
    var quantity = section.querySelector('[data-quantity-input]');
    if (quantity && event.target.closest('[data-quantity-minus]')) quantity.value = Math.max(1, Number(quantity.value || 1) - 1);
    if (quantity && event.target.closest('[data-quantity-plus]')) quantity.value = Math.max(1, Number(quantity.value || 1) + 1);
    if (event.target.closest('[data-mobile-submit]') && section.querySelector('[data-product-submit]')) section.querySelector('[data-product-submit]').click();
  });

  document.addEventListener('change', function (event) {
    var upsellSelector = event.target.closest('[data-upsell-variant]');
    if (upsellSelector) {
      var upsellOption = upsellSelector.options[upsellSelector.selectedIndex];
      upsellSelector.closest('form').querySelector('[data-upsell-price]').textContent = upsellOption.dataset.price;
      return;
    }
    var selector = event.target.closest('[data-product-variant-selector]');
    if (!selector) return;
    var option = selector.options[selector.selectedIndex];
    var section = selector.closest('[data-product-section]');
    var giftAmount = section.querySelector('[data-gift-card-amount]');
    if (giftAmount) giftAmount.textContent = option.dataset.giftValue;
    var available = option.dataset.available === 'true';
    var price = section.querySelector('[data-product-price]');
    if (price) price.textContent = option.dataset.price;
    var mobilePrice = section.querySelector('[data-mobile-price]');
    if (mobilePrice) mobilePrice.textContent = option.dataset.price;
    var compare = section.querySelector('[data-product-compare-price]');
    if (compare) {
      compare.textContent = option.dataset.comparePrice || '';
      compare.hidden = !!section.querySelector('[data-submit-price]') || !option.dataset.comparePrice;
    }
    var sale = section.querySelector('[data-sale-badge]');
    var priceRaw = Number(option.dataset.priceRaw || 0);
    var compareRaw = Number(option.dataset.compareRaw || 0);
    if (sale) {
      sale.textContent = compareRaw > priceRaw ? '-' + Math.round((compareRaw - priceRaw) * 100 / compareRaw) + '%' : '';
      sale.hidden = compareRaw <= priceRaw;
    }
    var button = section.querySelector('[data-product-submit]');
    var mobileButton = section.querySelector('[data-mobile-submit]');
    if (button) {
      button.disabled = !available;
      button.querySelector('[data-submit-label]').textContent = available ? button.dataset.addLabel : button.dataset.soldLabel;
    }
    if (mobileButton) mobileButton.disabled = !available;
    var submitPrice = button && button.querySelector('[data-submit-price]');
    if (submitPrice) {
      submitPrice.textContent = ' - ' + option.dataset.price;
      submitPrice.hidden = !available;
    }
    var mobileSubmitPrice = mobileButton && mobileButton.querySelector('[data-mobile-submit-price]');
    if (mobileSubmitPrice) {
      mobileSubmitPrice.textContent = ' - ' + option.dataset.price;
      mobileSubmitPrice.hidden = !available;
    }
    var stock = section.querySelector('[data-stock-status]');
    var inventory = Number(option.dataset.inventory || 0);
    var managed = option.dataset.managed === 'true';
    var threshold = Number(section.dataset.lowStockThreshold || 5);
    var lowStock = available && managed && inventory > 0 && inventory <= threshold;
    if (stock) {
      stock.classList.toggle('is-sold-out', !available);
      stock.classList.toggle('is-low', lowStock);
      var stockText = stock.querySelector('[data-stock-text]');
      if (stockText) {
        var statusLabel = available ? (lowStock ? section.dataset.lowStockLabel : section.dataset.inStockLabel) : section.dataset.soldOutLabel;
        if (lowStock && section.dataset.showStockQuantity === 'true') statusLabel += ' · ' + inventory;
        stockText.textContent = statusLabel;
      }
    }
    var delivery = section.querySelector('[data-delivery-text]');
    if (delivery) delivery.hidden = !available;
    var deliveryMode = section.dataset.deliveryMode;
    if (deliveryMode === 'auto') deliveryMode = available && (!managed || inventory > 0) ? 'stock' : 'production';
    section.querySelectorAll('[data-delivery-flow]').forEach(function (flow) { flow.hidden = flow.dataset.deliveryFlow !== deliveryMode; });
    var deliveryStatus = section.querySelector('[data-delivery-status]');
    if (deliveryStatus) {
      var deliveryLabel = deliveryMode === 'stock' ? section.dataset.stockFlowLabel : section.dataset.productionFlowLabel;
      if (deliveryMode === 'stock' && inventory > 0 && section.dataset.flowShowStockCount === 'true') deliveryLabel = inventory + ' ' + deliveryLabel;
      deliveryStatus.textContent = deliveryLabel;
    }
    var sku = section.querySelector('[data-product-sku]');
    if (sku) sku.textContent = option.dataset.sku || '—';
    if (option.dataset.mediaId) activateMedia(section.querySelector('[data-product-gallery]'), option.dataset.mediaId);
    var url = new URL(window.location.href);
    url.searchParams.set('variant', option.value);
    window.history.replaceState({}, '', url.toString());
  });

  function activateMedia(gallery, mediaId, scrollThumb) {
    if (!gallery || !mediaId) return;
    gallery.querySelectorAll('[data-media-id]').forEach(function (item) {
      var active = item.dataset.mediaId === String(mediaId);
      item.hidden = !active;
      item.classList.toggle('is-active', active);
      if (!active) item.querySelectorAll('video').forEach(function (video) { video.pause(); });
    });
    gallery.querySelectorAll('[data-media-target]').forEach(function (thumb) {
      var active = thumb.dataset.mediaTarget === String(mediaId);
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
      if (active && scrollThumb !== false) thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    });
  }

  function addDeliveryDays(days, excludeWeekends) {
    var date = new Date();
    date.setHours(12, 0, 0, 0);
    var added = 0;
    while (added < days) {
      date.setDate(date.getDate() + 1);
      if (!excludeWeekends || (date.getDay() !== 0 && date.getDay() !== 6)) added += 1;
    }
    if (excludeWeekends) {
      while (date.getDay() === 0 || date.getDay() === 6) date.setDate(date.getDate() + 1);
    }
    return date;
  }

  function formatDeliveryDate(date) {
    var locale = document.documentElement.lang || 'de-CH';
    return new Intl.DateTimeFormat(locale, { weekday: 'short', day: '2-digit', month: 'short' }).format(date);
  }

  function renderDeliveryDates(section) {
    var excludeWeekends = section.dataset.excludeWeekends === 'true';
    section.querySelectorAll('[data-delivery-date]').forEach(function (element) {
      var minDays = Number(element.dataset.minDays || 0);
      var maxDays = Number(element.dataset.maxDays || minDays);
      var minDate = formatDeliveryDate(addDeliveryDays(minDays, excludeWeekends));
      var maxDate = formatDeliveryDate(addDeliveryDays(maxDays, excludeWeekends));
      element.textContent = minDays === maxDays ? minDate : minDate + ' – ' + maxDate;
    });
  }

  function initializeDeliveryDates(root) {
    root.querySelectorAll('[data-product-section]').forEach(renderDeliveryDates);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeDeliveryDates(document); });
  } else {
    initializeDeliveryDates(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initializeDeliveryDates(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rocket-about-world"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-about-world]').forEach((section) => {
    const clock = section.querySelector('[data-world-clock]');
    if (!clock) return;
    const updateClock = () => { clock.textContent = `${new Date().toISOString().slice(11, 19)} UTC`; };
    updateClock();
    window.setInterval(updateClock, 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rocket-exchange-form"] && !Shopify.designMode) return;
  try {
    
(() => {
  function setup(root) {
    if (root.dataset.exchangeReady) return;
    root.dataset.exchangeReady = 'true';
    const checkbox = root.querySelector('[data-exchange-confirm]');
    const actions = root.querySelector('[data-exchange-actions]');
    const button = root.querySelector('[data-exchange-open]');
    const embed = root.querySelector('[data-exchange-embed]');
    const host = root.querySelector('[data-exchange-host]');
    const status = root.querySelector('[data-exchange-status]');
    const error = root.querySelector('[data-exchange-error]');
    let loaded = false;
    const sync = () => {
      actions.hidden = !checkbox.checked;
      if (!checkbox.checked) {
        embed.hidden = true;
        root.classList.remove('is-form-open');
        button.setAttribute('aria-expanded', 'false');
      }
    };
    checkbox.checked = false;
    sync();
    checkbox.addEventListener('change', sync);
    window.addEventListener('pageshow', sync);
    button.addEventListener('click', () => {
      if (!checkbox.checked) return;
      embed.hidden = false;
      root.classList.add('is-form-open');
      button.setAttribute('aria-expanded', 'true');
      root.querySelector('[data-exchange-form-heading]').focus({preventScroll:true});
      embed.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
      if (loaded) return;
      loaded = true;
      const observer = new MutationObserver(() => {
        if (host.querySelector('iframe') || document.querySelector('#retino-portal-containerretino-portal-6f3d iframe')) {
          status.hidden = true;
          observer.disconnect();
        }
      });
      observer.observe(document.body, {childList:true,subtree:true});
      const script = document.createElement('script');
      script.src = 'https://cdn.retino.com/embeddedFormInjector.js';
      script.async = true;
      script.addEventListener('error', () => {
        status.hidden = true;
        error.hidden = false;
        loaded = false;
        script.remove();
        observer.disconnect();
      });
      document.head.appendChild(script);
    });
  }
  document.querySelectorAll('[data-exchange-gate]').forEach(setup);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-exchange-gate]').forEach(setup));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rocket-manual-reader"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rocket-manual-reader')) {
  class RocketManualReader extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.config = JSON.parse(this.querySelector('[data-rgm-config]').textContent);
      this.dialog = this.querySelector('dialog');
      this.stage = this.querySelector('.rgm-stage');
      this.figure = this.querySelector('.rgm-page-figure');
      this.image = this.querySelector('[data-rgm-image]');
      this.pageInput = this.querySelector('[data-rgm-page]');
      this.status = this.querySelector('[data-rgm-status]');
      this.error = this.querySelector('[data-rgm-error]');
      this.page = 1;
      this.zoom = 1;
      this.sequence = 0;
      const on = (el, type, fn) => el.addEventListener(type, fn, {signal});
      this.querySelectorAll('[data-rgm-open]').forEach(button => on(button, 'click', () => this.openReader()));
      on(this.querySelector('[data-rgm-close]'), 'click', () => this.dialog.close());
      on(this.querySelector('[data-rgm-prev]'), 'click', () => this.go(this.page - 1));
      on(this.querySelector('[data-rgm-next]'), 'click', () => this.go(this.page + 1));
      on(this.pageInput, 'change', () => this.selectPage());
      on(this.pageInput, 'keydown', event => {
        if (event.key === 'Enter') { event.preventDefault(); this.selectPage(); }
      });
      on(this.querySelector('[data-rgm-minus]'), 'click', () => this.setZoom(this.zoom - .25));
      on(this.querySelector('[data-rgm-plus]'), 'click', () => this.setZoom(this.zoom + .25));
      on(this.querySelector('[data-rgm-fit]'), 'click', () => this.setZoom(1));
      on(this.dialog, 'keydown', event => {
        if (event.target.matches('input,select,textarea')) return;
        if (event.key === 'ArrowLeft') { event.preventDefault(); this.go(this.page - 1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); this.go(this.page + 1); }
      });
      on(this.dialog, 'click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
      on(this.dialog, 'close', () => {
        this.restoreScroll();
        this.opener?.focus({preventScroll:true});
      });
      on(this.stage, 'touchstart', event => {
        this.touchStart = event.touches.length === 1 ? {x:event.touches[0].clientX,y:event.touches[0].clientY} : null;
      });
      on(this.stage, 'touchend', event => {
        if (!this.touchStart || this.zoom !== 1 || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - this.touchStart.x;
        const dy = event.changedTouches[0].clientY - this.touchStart.y;
        this.touchStart = null;
        if (Math.abs(dx) > 70 && Math.abs(dx) > Math.abs(dy) * 1.7) this.go(this.page + (dx < 0 ? 1 : -1));
      });
      this.querySelectorAll('[data-rgm-download]').forEach(link => on(link, 'click', event => this.download(event,link)));
      this.observer = new ResizeObserver(() => this.fitPage());
      this.observer.observe(this.stage);
      this.updateControls();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      this.sequence++;
      this.restoreScroll();
      if (this.downloadUrl) URL.revokeObjectURL(this.downloadUrl);
    }
    openReader() {
      if (this.dialog.open) return;
      this.opener = document.activeElement;
      this.oldOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.scrollLocked = true;
      this.dialog.showModal();
      this.zoom = 1;
      this.fitPage();
      this.go(this.page);
    }
    restoreScroll() {
      if (!this.scrollLocked) return;
      document.documentElement.style.overflow = this.oldOverflow;
      this.scrollLocked = false;
    }
    selectPage() {
      const n = Number(this.pageInput.value);
      if (!Number.isInteger(n) || n < 1 || n > this.config.pages.length) {
        this.pageInput.value = this.page;
        return;
      }
      this.go(n);
    }
    updateControls() {
      this.pageInput.value = this.page;
      this.querySelector('[data-rgm-prev]').disabled = this.page === 1;
      this.querySelector('[data-rgm-next]').disabled = this.page === this.config.pages.length;
      this.querySelector('[data-rgm-minus]').disabled = this.zoom === 1;
      this.querySelector('[data-rgm-plus]').disabled = this.zoom === 3;
      this.querySelector('[data-rgm-fit]').setAttribute('aria-pressed',String(this.zoom === 1));
    }
    pageStatus() {
      return `${this.config.pageLabel} ${this.page} ${this.config.ofLabel} ${this.config.pages.length}`;
    }
    async go(number) {
      if (number < 1 || number > this.config.pages.length) return;
      const seq = ++this.sequence;
      const oldPage = this.loadedPage || this.page;
      this.page = number;
      this.updateControls();
      this.error.hidden = true;
      this.figure.setAttribute('aria-busy','true');
      this.status.textContent = this.config.loading;
      try {
        const next = new Image();
        next.src = this.config.pages[number - 1];
        await next.decode();
        if (seq !== this.sequence || !this.isConnected) return;
        this.image.src = next.src;
        this.loadedPage = number;
        this.querySelector('[data-rgm-page-text]').textContent = `${this.pageStatus()}\n${this.config.texts[number - 1]}`;
        this.stage.scrollTop = 0;
        this.stage.scrollLeft = 0;
        this.status.textContent = this.pageStatus();
        this.fitPage();
        if (number < this.config.pages.length) {
          const preload = new Image();
          preload.src = this.config.pages[number];
        }
      } catch {
        if (seq !== this.sequence || !this.isConnected) return;
        this.page = oldPage;
        this.updateControls();
        this.error.hidden = false;
        this.status.textContent = this.pageStatus();
      } finally {
        if (seq === this.sequence) this.figure.setAttribute('aria-busy','false');
      }
    }
    fitPage() {
      if (!this.dialog.open) return;
      const padding = innerWidth < 750 ? 32 : 48;
      const width = Math.max(100,Math.min(this.stage.clientWidth - padding,(this.stage.clientHeight - padding) * 1600 / 2271));
      this.figure.style.setProperty('--rgm-page-width',`${Math.round(width * this.zoom)}px`);
    }
    setZoom(value) {
      this.zoom = Math.min(3,Math.max(1,value));
      this.updateControls();
      this.fitPage();
    }
    async download(event,link) {
      if (this.downloadUrl) {
        link.href = this.downloadUrl;
        return;
      }
      event.preventDefault();
      if (this.downloading) return;
      this.downloading = true;
      const label = link.textContent;
      link.textContent = this.config.downloadLoading;
      try {
        const response = await fetch(this.config.pdf,{signal:this.controller.signal});
        if (!response.ok) throw new Error('PDF unavailable');
        const blob = await response.blob();
        if (!this.isConnected) return;
        this.downloadUrl = URL.createObjectURL(blob);
        this.querySelectorAll('[data-rgm-download]').forEach(a => { a.href = this.downloadUrl; });
        const a = document.createElement('a');
        a.href = this.downloadUrl;
        a.download = 'Rocket_Games_Manual.pdf';
        document.body.append(a);
        a.click();
        a.remove();
      } catch {
        if (this.isConnected) window.location.assign(this.config.pdf);
      } finally {
        this.downloading = false;
        link.textContent = label;
      }
    }
  }
  customElements.define('rocket-manual-reader',RocketManualReader);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rocket-parallax"] && !Shopify.designMode) return;
  try {
    
  function initRocketMotionSlider(root) {
    if (!root || root.dataset.motionSliderReady === 'true') return;
    const slides = Array.from(root.querySelectorAll('[data-motion-slide]'));
    if (slides.length < 2) return;
    const copies = Array.from(root.querySelectorAll('[data-motion-copy-panel]'));
    const dots = Array.from(root.querySelectorAll('[data-motion-dot]'));
    const stageLabel = root.querySelector('[data-motion-stage-label]');
    let active = 0;

    function selectSlide(index) {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === active);
        slide.classList.toggle('is-before', slideIndex < active);
        slide.setAttribute('aria-hidden', String(slideIndex !== active));
      });
      copies.forEach((panel, panelIndex) => {
        panel.classList.toggle('is-active', panelIndex === active);
        panel.setAttribute('aria-hidden', String(panelIndex !== active));
      });
      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === active);
        dot.setAttribute('aria-pressed', String(dotIndex === active));
      });
      if (stageLabel) stageLabel.textContent = slides[active].dataset.stageLabel || '';
    }

    dots.forEach(dot => dot.addEventListener('click', () => selectSlide(Number(dot.dataset.motionIndex))));

    root.dataset.motionSliderReady = 'true';
    selectSlide(0);
  }

  document.querySelectorAll('[data-misaki-section]').forEach(initRocketMotionSlider);
  document.addEventListener('shopify:section:load', event => {
    initRocketMotionSlider(event.target.querySelector('[data-misaki-section]'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rocket-return-form"] && !Shopify.designMode) return;
  try {
    
(() => {
  function setup(root) {
    if (root.dataset.returnReady) return;
    root.dataset.returnReady = 'true';
    const checkbox = root.querySelector('[data-return-confirm]');
    const actions = root.querySelector('[data-return-actions]');
    const button = root.querySelector('[data-return-open]');
    const embed = root.querySelector('[data-return-embed]');
    const host = root.querySelector('[data-return-host]');
    const status = root.querySelector('[data-return-status]');
    const error = root.querySelector('[data-return-error]');
    let loaded = false;
    const sync = () => {
      actions.hidden = !checkbox.checked;
      if (!checkbox.checked) {
        embed.hidden = true;
        root.classList.remove('is-form-open');
        button.setAttribute('aria-expanded', 'false');
      }
    };
    checkbox.checked = false;
    sync();
    checkbox.addEventListener('change', sync);
    window.addEventListener('pageshow', sync);
    button.addEventListener('click', () => {
      if (!checkbox.checked) return;
      embed.hidden = false;
      root.classList.add('is-form-open');
      button.setAttribute('aria-expanded', 'true');
      root.querySelector('[data-return-form-heading]').focus({preventScroll:true});
      embed.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
      if (loaded) return;
      loaded = true;
      const observer = new MutationObserver(() => {
        if (host.querySelector('iframe') || document.querySelector('#retino-portal-containerretino-portal-6f3d iframe')) {
          status.hidden = true;
          observer.disconnect();
        }
      });
      observer.observe(document.body, {childList:true,subtree:true});
      const script = document.createElement('script');
      script.src = 'https://cdn.retino.com/embeddedFormInjector.js';
      script.async = true;
      script.addEventListener('error', () => {
        status.hidden = true;
        error.hidden = false;
        loaded = false;
        script.remove();
        observer.disconnect();
      });
      document.head.appendChild(script);
    });
  }
  document.querySelectorAll('[data-return-gate]').forEach(setup);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-return-gate]').forEach(setup));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rocket-side-promo"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = root => {
      root.querySelectorAll('[data-rocket-side-promo]').forEach(promo => {
        if (promo.dataset.initialized === 'true') return;
        promo.dataset.initialized = 'true';

        const panel = promo.querySelector('[data-promo-panel]');
        const closeButton = promo.querySelector('[data-promo-close]');
        const openButton = promo.querySelector('[data-promo-open]');
        const storageKey = promo.dataset.storageKey;
        const rememberClose = promo.dataset.rememberClose === 'true';
        const designMode = Boolean(window.Shopify && window.Shopify.designMode);
        let dismissed = false;

        if (rememberClose && !designMode) {
          try {
            dismissed = window.sessionStorage.getItem(storageKey) === 'closed';
          } catch (error) {
            dismissed = false;
          }
        }

        const setOpen = (isOpen, moveFocus = false) => {
          promo.hidden = false;
          promo.classList.add('is-ready');
          promo.classList.toggle('is-collapsed', !isOpen);
          panel.setAttribute('aria-hidden', String(!isOpen));

          if (openButton) {
            openButton.hidden = isOpen;
            openButton.setAttribute('aria-expanded', String(isOpen));
          }

          if (moveFocus) {
            if (isOpen) closeButton.focus();
            if (!isOpen && openButton) openButton.focus();
          }
        };

        closeButton.addEventListener('click', () => {
          if (rememberClose && !designMode) {
            try {
              window.sessionStorage.setItem(storageKey, 'closed');
            } catch (error) {
              dismissed = true;
            }
          }
          setOpen(false, true);
        });

        if (openButton) {
          openButton.addEventListener('click', () => setOpen(true, true));
        }

        promo.addEventListener('keydown', event => {
          if (event.key === 'Escape' && !promo.classList.contains('is-collapsed')) {
            setOpen(false, true);
          }
        });

        if (dismissed) {
          setOpen(false);
          return;
        }

        const delay = designMode ? 0 : Number(promo.dataset.delay || 0);
        window.setTimeout(() => setOpen(true), delay);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document));
    } else {
      initialize(document);
    }

    document.addEventListener('shopify:section:load', event => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rocket-trade-in-promo"] && !Shopify.designMode) return;
  try {
    

  function initializeTradePromo(root) {
    const sections = [];
    if (root.matches && root.matches('[data-trade-promo]')) sections.push(root);
    root.querySelectorAll('[data-trade-promo]').forEach(section => sections.push(section));
    sections.forEach(section => {
      const savings = section.querySelector('[data-trade-promo-savings]');
      const amountElement = section.querySelector('[data-trade-promo-amount]');
      if (!savings || !amountElement) return;
      const amount = Number(section.dataset.creditEur);
      const currency = section.dataset.currency;
      const exchange = window.Shopify && window.Shopify.currency;
      const rate = currency === 'EUR' ? 1 : Number(exchange && exchange.rate);
      const validRate = currency === 'EUR' || section.dataset.baseCurrency === 'EUR' && exchange && exchange.active === currency && Number.isFinite(rate) && rate > 0;
      if (!Number.isFinite(amount) || amount <= 0 || !validRate) {
        savings.hidden = true;
        return;
      }
      try {
        const locale = document.documentElement.lang || 'de';
        const fractionDigits = new Intl.NumberFormat(locale, { style: 'currency', currency }).resolvedOptions().maximumFractionDigits;
        const factor = Math.pow(10, fractionDigits);
        const converted = Math.round(amount * rate * factor) / factor;
        amountElement.textContent = new Intl.NumberFormat(locale, {
          style: 'currency',
          currency,
          minimumFractionDigits: Number.isInteger(converted) ? 0 : fractionDigits,
          maximumFractionDigits: fractionDigits
        }).format(converted);
        savings.hidden = false;
      } catch {
        savings.hidden = true;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeTradePromo(document));
  } else {
    initializeTradePromo(document);
  }
  document.addEventListener('shopify:section:load', event => initializeTradePromo(event.target));

  } catch(e) { console.error(e); }
})();
})();
